































import { Component, Prop, Vue } from "vue-property-decorator";
import { ACTIONS } from "@/event-bus";
@Component
export default class ModalBase extends Vue {
  @Prop(Boolean) private showHeader!: boolean;

  /// Styles
  @Prop(Object) private bodyStyle!: any;
  @Prop(Object) private headerStyle!: any;
  @Prop(Object) private containerStyle!: any;

  private close() {
    this.$emit(ACTIONS.CLOSE);
  }

  private mounted() {
    const wrapper = document.getElementsByTagName("body")[0];
    wrapper.classList.add("modal-on");
  }

  private beforeDestroy() {
    const wrapper = document.getElementsByTagName("body")[0];
    wrapper.classList.remove("modal-on");
  }
}
